export enum UserRoles {
  ADMIN = 'ADMIN',
  SALES = 'SALES',
}
